export default "__VITE_PUBLIC_ASSET__9772805b__"